/**
 * Timestamps in words.
 */

/**
 * A timestamp as a Date. A date-time without an offset is read as UTC — that
 * is how the API sends them — rather than as local time, which would put
 * every "updated" label hours out for anyone not in UTC.
 */
export function parseTimestamp(value: string | Date | null | undefined): Date | null {
  if (!value) return null;
  if (value instanceof Date) return Number.isNaN(value.getTime()) ? null : value;
  const hasZone = /([zZ]|[+-]\d{2}:?\d{2})$/.test(value);
  const parsed = new Date(value.includes('T') && !hasZone ? `${value}Z` : value);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
}

/** "just now", "5m ago", "3h ago", "yesterday", "4d ago", then the date. */
export function formatRelativeTime(
  value: string | Date | null | undefined,
  now: number = Date.now(),
): string | null {
  const date = parseTimestamp(value);
  if (!date) return null;
  const minutes = Math.round((now - date.getTime()) / 60000);
  if (minutes < 1) return 'just now';
  if (minutes < 60) return `${minutes}m ago`;
  const hours = Math.round(minutes / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.round(hours / 24);
  if (days === 1) return 'yesterday';
  if (days < 7) return `${days}d ago`;
  return date.toLocaleDateString(undefined, { day: 'numeric', month: 'short', year: 'numeric' });
}
